module.exports = __webpack_public_path__ + "img/discovery.d4d98fee.svg";